import React, { Component } from 'react';

import About from './About/About';
import Clients from './Clients/Clients';
// import Slider from './Slider/Slider-ui';
import Services from './Services/Services';
import Team from './Team/Team';

// import { usePosts } from 'react-wordpress-hooks';

const Home = (props) => {

  window.scrollTo(0, 0);

  return (
    <React.Fragment>
      {/* <Slider lang={props.lang} /> */}

      <About lang={props.lang} />

      <Services lang={props.lang} />

      <Team lang={props.lang} />

      <Clients lang={props.lang} />

      {/* <a href="#root" className="go2top">
                    <i className="fa fa-arrow-up"></i>
                </a> */}
    </React.Fragment>
  );
}

export default Home;